import React from 'react';
import ReactExport from 'react-export-excel';
import moment from 'moment';
import { commissionReportCRMColoums, performanceReportColoums } from '@constants';
import { isAuth } from '@helpers';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export const CommissionExcelDownload = ({ filename, dataSet, userDetails }) => {
	return (
		<>
			{isAuth(commissionReportCRMColoums, userDetails.accessLevel) ? (
				<ExcelFile filename={filename}>
					<ExcelSheet data={dataSet} name={moment(new Date()).format('MM/DD/YYYY')}>
						<ExcelColumn label="Customer" value={(col) => col.profile.customerName} />
						<ExcelColumn label="Commission %" value={(col) => col.profile.commissionPerc} />
						<ExcelColumn
							label="Commission Amount"
							value={(row) =>
								row.profile && row.profile.commissionAmount ? row.profile.currencySymbol + ' ' + row.profile.commissionAmount : ''
							}
						/>
						<ExcelColumn label="Order" value={(col) => col.profile.order} />
						<ExcelColumn label="Product" value={(col) => col.profile.product} />
						<ExcelColumn
							label="Product Price"
							value={(row) =>
								row.profile && row.profile.orderPrice ? row.profile.currencySymbol + ' ' + row.profile.orderPrice : null
							}
						/>
						<ExcelColumn label="CommissionStatus" value={(col) => col.profile.orderPrice} />
						<ExcelColumn label="Report Price" value={(col) => col.profile.dateCreated} />
					</ExcelSheet>
				</ExcelFile>
			) : (
				<ExcelFile filename={filename}>
					<ExcelSheet data={dataSet} name={moment(new Date()).format('MM/DD/YYYY')}>
						<ExcelColumn label="Affiliate Name" value={(col) => col.profile.affiliateName} />
						<ExcelColumn label="Customer" value={(col) => col.profile.customerName} />
						<ExcelColumn label="Company" value={(col) => col.profile.customerName} />
						<ExcelColumn label="Commission %" value={(col) => col.profile.commissionPerc} />
						<ExcelColumn
							label="Commission Amount"
							value={(row) =>
								row.profile && row.profile.commissionAmount ? row.profile.currencySymbol + ' ' + row.profile.commissionAmount : ''
							}
						/>
						<ExcelColumn label="Order" value={(col) => col.profile.order} />
						<ExcelColumn label="Product" value={(col) => col.profile.product} />
						<ExcelColumn
							label="Product Price"
							value={(row) =>
								row.profile && row.profile.orderPrice ? row.profile.currencySymbol + ' ' + row.profile.orderPrice : null
							}
						/>
						<ExcelColumn label="CommissionStatus" value={(col) => col.profile.orderPrice} />
						<ExcelColumn label="Report Price" value={(col) => col.profile.dateCreated} />
					</ExcelSheet>
				</ExcelFile>
			)}
		</>
	);
};

export const PerformanceExcelDownload = ({ filename, dataSet, userDetails }) => {
	const affiliatePerformance = [
		{ label: 'Date', value: 'dateCreated' },
		{ label: 'Campaign', value: 'categoryName' },
		{ label: 'Clicks', value: 'clicks' },
		{ label: 'CPC Commission', value: 'cpcCommission' },
		{ label: 'PARTIAL', value: 'partials' },
		{ label: 'partialPerc', value: 'partialPerc' },
		{ label: 'declines', value: 'declines' },
		{ label: 'declinePerc', value: 'declinePerc' },
		{ label: 'sales', value: 'sales' },
		{ label: 'conversions', value: 'conversions' },
		{ label: 'conversionPerc', value: 'conversionPerc' },
		{ label: 'step1Commission', value: 'step1Commission' },
		{ label: 'saleTotal', value: 'saleTotal' },
		{ label: 'upsells', value: 'upsells' },
		{ label: 'upsellPerc', value: 'upsellPerc' },
		{ label: 'upsellTotal', value: 'upsellTotal' },
		{ label: 'step2Commission', value: 'step2Commission' },
		{ label: 'netTotal', value: 'netTotal' },
		{ label: 'avgTicket', value: 'avgTicket' },
	];
	const merchantPerformance = [
		{ label: 'company', value: 'company' },
		{ label: 'Affiliate', value: 'affiliateName' },
		{ label: 'Date', value: 'dateCreated' },
		{ label: 'Campaign', value: 'categoryName' },
		{ label: 'Clicks', value: 'clicks' },
		{ label: 'CPC Commission', value: 'cpcCommission' },
		{ label: 'PARTIAL', value: 'partials' },
		{ label: 'partialPerc', value: 'partialPerc' },
		{ label: 'declines', value: 'declines' },
		{ label: 'declinePerc', value: 'declinePerc' },
		{ label: 'sales', value: 'sales' },
		{ label: 'conversions', value: 'conversions' },
		{ label: 'conversionPerc', value: 'conversionPerc' },
		{ label: 'step1Commission', value: 'step1Commission' },
		{ label: 'saleTotal', value: 'saleTotal' },
		{ label: 'upsells', value: 'upsells' },
		{ label: 'upsellPerc', value: 'upsellPerc' },
		{ label: 'upsellTotal', value: 'upsellTotal' },
		{ label: 'step2Commission', value: 'step2Commission' },
		{ label: 'netTotal', value: 'netTotal' },
		{ label: 'avgTicket', value: 'avgTicket' },
	];
	return (
		// <></>
		<ExcelFile filename={filename}>
			<ExcelSheet data={dataSet} name={moment(new Date()).format('MM/DD/YYYY')}>
				{isAuth(performanceReportColoums, userDetails.accessLevel)
					? merchantPerformance.map((Column) => {
							if (Column) {
								return <ExcelColumn label={Column.label} value={(col) => col[Column.value]} />;
							}
					  })
					: affiliatePerformance.map((Column) => {
							if (Column) {
								return <ExcelColumn label={Column.label} value={(col) => col[Column.value]} />;
							}
					  })}
			</ExcelSheet>
		</ExcelFile>
	);
};

export const AffiliateReportExcelDownload = ({ filename, dataSet = [], userDetails = {} }) => {
	return (
		// <></>
		<ExcelFile filename={filename}>
			<ExcelSheet data={dataSet} name={moment(new Date()).format('MM/DD/YYYY')}>
				<ExcelColumn label="Affiliate Name" value={(col) => col.sourceTitle} />
				<ExcelColumn label="Campaign" value={(col) => col.campaignName} />
				<ExcelColumn label="Affiliate ID" value={(col) => col.clientSourceId} />
				<ExcelColumn label="status" value={(row) => row.statusDesc} />
			</ExcelSheet>
		</ExcelFile>
	);
};

export const AffiliateUsageExcelDownload = ({ filename, dataSet = [], userDetails = {} }) => {
	return (
		// <></>
		<ExcelFile filename={filename}>
			<ExcelSheet data={dataSet} name={moment(new Date()).format('MM/DD/YYYY')}>
				<ExcelColumn label="Company ID" value={(col) => col.companyId} />
				<ExcelColumn label="Affiliate Name" value={(col) => col.affiliateName} />
				<ExcelColumn label="Date Of Last Visit" value={(col) => col.lastVisitDate} />
				<ExcelColumn label="Visits" value={(row) => row.totalVisit} />
				<ExcelColumn label="ALSV" value={(row) => row.avgSession} />
			</ExcelSheet>
		</ExcelFile>
	);
};

export const CommissionSummaryExcelDownload = ({ filename, dataSet = [], userDetails = {} }) => {
	return (
		// <></>
		<ExcelFile filename={filename}>
			<ExcelSheet data={dataSet} name={moment(new Date()).format('MM/DD/YYYY')}>
				<ExcelColumn label="Affiliate Name" value={(col) => col.affiliateName} />
				<ExcelColumn label="Report Date" value={(col) => col.reportDate} />
				<ExcelColumn label="Commission Amount" value={(col) => col.commissionAmount} />
				<ExcelColumn label="Commission Status" value={(row) => row.status} />
			</ExcelSheet>
		</ExcelFile>
	);
};

export const AffiliateCommissionSummaryExcelDownload = ({ filename, dataSet = [], userDetails = {} }) => {
	return (
		// <></>
		<ExcelFile filename={filename}>
			<ExcelSheet data={dataSet} name={moment(new Date()).format('MM/DD/YYYY')}>
				<ExcelColumn label="Report Date" value={(col) => col.reportDate} />
				<ExcelColumn label="Commission Amount" value={(col) => col.commissionAmount} />
				<ExcelColumn label="Commission Status" value={(row) => row.status} />
			</ExcelSheet>
		</ExcelFile>
	);
};
